import AllInclusiveRoundedIcon from '@mui/icons-material/AllInclusiveRounded';
import AttachMoneyRoundedIcon from '@mui/icons-material/AttachMoneyRounded';
import AutoFixHighRoundedIcon from '@mui/icons-material/AutoFixHighRounded';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';

import Values from '../InventoryItem/Components/Values';
import Prices from '../InventoryItem/Components/Prices';
import SelectInventoryItem from './Components/SelectInventoryItem';
import SelectWigBrand from './Components/SelectWigBrand';

import * as Yup from 'yup';

import { displayInventoryItemLabel } from '../../utils/displayLabels';

import { formatLength } from '../../utils/util';

import WigIdComponent from './Components/WigIdComponent';

import WigBalance from './Components/WigBalance';

const headers = [
  {
    label: 'Wig Code',
    id: 'wig_id'
  },
  {
    label: 'Brand',
    id: 'brand_name'
  },
  // {
  //   label: 'SKU',
  //   id: 'sku'
  // },
  {
    label: 'Color',
    id: 'color'
  },
  {
    label: 'Length',
    id: 'length',
    render: (row) => formatLength(row?.length, row?.length_unit)
  },
  // {
  //   label: 'Cap',
  //   id: 'cap_size'
  // },
  {
    label: 'Material',
    id: 'material'
  },
  {
    label: 'Status',
    id: 'status',
    multi: true,
    values: [{value: "stock", label: "Stock", status: "success"}, {value: "sold", label: "Sold", status: "info"}, {value: "assigned", label: "Assigned", status: "warning"}, {value: "hold", label: "Hold", status: "warning"}, {value: "removed", label: "Returned", status: "error"}]
  },
  {
    label: "Location",
    id: "location",
    render: row => {
      let location;
      switch (row.status) {
        case "sold":
          location = row.customer_name || "Sold";
          break;
        case "removed":
          location = row.brand_name || "Returned";
          break;
        case "hold":
          location = row.customer_name || "Hold";
          break;
        case "assigned":
          location = <div>Inventory <br /> <span>Assigned: {row.customer_name}</span></div>
          break;
        default:
          location = "Inventory";
          break;
      }
      return location;
    }
  },
  // {
  //   label: 'Entered On',
  //   dateShort: true,
  //   id: 'date_entered'
  // },
  {
    label: "Price",
    id: "total_paid",
    render: (row) => <WigBalance wig={row} />
  },
  {
    label: "Date Sold",
    dateShort: true,
    id: "date_sold"
  },
  {
    label: "Sale Rep",
    id: "sales_rep"
  }
];

const mobile_headers = [
   {
    label: 'Wig Code',
    id: 'wig_id'
  },
  {
    label: 'SKU',
    id: 'sku'
  },
  {
    label: 'Price',
    id: 'total_price',
    currency: true
  },
  // {
  //   label: 'Length',
  //   id: 'length'
  // },
  {
    label: 'Status',
    id: 'status',
    multi: true,
    values: [{value: "stock", status: "success"}, {value: "sold", status: "info"}, {value: "removed", status: "error"}]
  }
]

const tabs = [
  {id: "all", label: "All", Icon: AllInclusiveRoundedIcon },
  {id: "stock", label: "Stock", Icon: Inventory2OutlinedIcon },
  {id: "sold", label: "Sold", Icon: AttachMoneyRoundedIcon },
  {id: "removed", label: "Returned", Icon: AutoFixHighRoundedIcon },
  {id: "assigned", label: "Assigned", Icon: AssignmentTurnedInOutlinedIcon },
]

const filters = [
  {
    id: "date_entered",
    type: "date",
    label: "Entered On",
  },
  {
    id: "date_sold",
    type: "date",
    label: "Sold Date",
  },
  {
    id: "u.display_name",
    type: "autoMulti",
    label: "Sales Rep",
    url: '/users',
    fieldOptions: {
      fieldName: "display_name",
      displayField: "display_name"
    },
    prefetch: true
  },
  {
    id: "brand_name",
    type: "autoMulti",
    label: "Brands",
    url: '/vendors/brands',
    fieldOptions: {
      fieldName: "brand_name",
      displayField: "brand_name"
    },
    prefetch: true
  },
  {
    id: "length",
    type: "number",
    label: "Length",
  },
  {
    id: "color",
    type: "autoMulti",
    label: "Color",
    url: '/inventory_values/colors/all',
    fieldOptions: {
      fieldName: "value",
      displayField: "value"
    },
    prefetch: true
  },
  {
    id: "material",
    type: "autoMulti",
    label: "Wig Type",
    url: '/inventory_values/values/all?attribute[$eq]=material',
    fieldOptions: {
      fieldName: "value",
      displayField: "value"
    },
    prefetch: true
  },
  {
    id: "hairstyle",
    type: "autoMulti",
    label: "Hairstyle",
    url: '/inventory_values/values/all?attribute[$eq]=hairstyle',
    fieldOptions: {
      fieldName: "value",
      displayField: "value"
    },
    prefetch: true
  },
  {
    id: "line",
    type: "autoMulti",
    label: "Wig Line",
    url: '/inventory_values/values/all?attribute[$eq]=line',
    fieldOptions: {
      fieldName: "value",
      displayField: "value"
    },
    prefetch: true
  },
]

const fields = [
  // { 
  //   fieldType: "formField",
  //   formFieldType: "toggle",
  //   name: "wig_type",
  //   label: "Item Type",
  //   type: "text",
  //   options: [{value: "inventory", label: "Inventory Item"}, {value: "custom", label: "Custom Item"}],
  //   size: {xs: 12, lg: 12},
  // },
  {
    fieldType: "Component",
    Component: <WigIdComponent/>,
    name: "wig_id",
    size: {xs: 12},
  },
  {
    fieldType: "divider",
    header: "Wig Details",
    name: "wig_details",
    // checkDisplayField: (values) => values?.wig_type === "custom",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "Component",
    Component: <SelectInventoryItem />,
    name: "select_inventory_item",
    size: {xs: 12, lg: 12},
  },
  // {
  //   fieldType: "Component",
  //   Component: <SelectWigBrand />,
  //   name: "select_wig_brand",
  //   size: {xs: 12, lg: 12},
  // },
  // {
  //   fieldType: "Component",
  //   Component: <Values />,
  //   name: "values",
  //   // checkDisplayField: (values) => values?.wig_type === "custom",
  //   size: {xs: 12, lg: 12},
  // },
  {
    fieldType: "formField",
    formFieldType: "switch",
    name: "save_item",
    label: "Save As New Inventory Item",
    type: "checkbox",
    checkDisplayField: (values) => values?.wig_type === "custom",
    size: {xs: 12},
  },
  {
    fieldType: "divider",
    header: "Price Information",
    name: "price_info",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "Component",
    Component: <Prices />,
    // checkDisplayField: (values) => values?.wig_type === "custom",
    name: "price",
    size: {xs: 12, lg: 12},
  },
  // {
  //   fieldType: "formField",
  //   formFieldType: "text",
  //   name: "cost_subtotal",
  //   label: "Cost",
  //   type: "number",
  //   checkDisplayField: (values) => values?.wig_type !== "custom",
  //   size: {xs: 12, md: 4},
  // }, 
  // {
  //   fieldType: "formField",
  //   formFieldType: "text",
  //   name: "price",
  //   label: "Price",
  //   type: "number",
  //   checkDisplayField: (values) => values?.wig_type !== "custom",
  //   size: {xs: 12, md: 4},
  // },
  // {
  //   fieldType: "formField",
  //   formFieldType: "text",
  //   name: "service_price",
  //   label: "Service Price (optional)",
  //   type: "number",
  //   checkDisplayField: (values) => values?.wig_type !== "custom",
  //   size: {xs: 12, md: 4},
  // }
]

const edit_fields = [
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "wig_id",
    label: "Wig Code",
    type: "text",
    checkDisabled: () => true,
    helperText: "Cannot be updated after creation. If you need to change this, please create a new inventory item.",
    size: {xs: 12},
  },
  {
    fieldType: "divider",
    header: "Wig Details",
    name: "wig_details",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "debounceSearchSolo",
    name: "brand_name",
    label: "Select Wig Brand",
    url: "vendors/brands",
    fieldName: "brand_name",
    displayField: "brand_name",
    // formUpdates: [{name: "vendor_id", field: "vendor_id"}],
    checkDisabled: () => true,
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "Component",
    Component: <Values />,
    name: "values",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "divider",
    header: "Price Information",
    name: "price_info",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "Component",
    Component: <Prices />,
    // checkDisplayField: (values) => values?.wig_type === "custom",
    name: "price",
    size: {xs: 12, lg: 12},
  },
  // {
  //   fieldType: "formField",
  //   formFieldType: "text",
  //   name: "cost_subtotal",
  //   label: "Cost",
  //   type: "number",
  //   checkDisplayField: (values) => values?.wig_type !== "custom",
  //   size: {xs: 12, md: 4},
  // }, 
  // {
  //   fieldType: "formField",
  //   formFieldType: "text",
  //   name: "price",
  //   label: "Price",
  //   type: "number",
  //   checkDisplayField: (values) => values?.wig_type !== "custom",
  //   size: {xs: 12, md: 4},
  // },
  // {
  //   fieldType: "formField",
  //   formFieldType: "text",
  //   name: "service_price",
  //   label: "Service Price (optional)",
  //   type: "number",
  //   checkDisplayField: (values) => values?.wig_type !== "custom",
  //   size: {xs: 12, md: 4},
  // }
]

const initialValues = {
  wig_id: '',
  vendor_id: "",
  inventory_item_id: '',
  brand_name: '',
  length: '',
  length_unit: 'in',
  color: '',
  material: '',
  hairstyle: '',
  line: '',
  cap_size: '',
  cost_subtotal: "",
  price: "",
  service_price: "",
  has_highlights: false,
  wig_type: "inventory",
  save_item: true
}

const additionalState = {
  inventory_item: null,
  sku: '',
}

const schema = Yup.object().shape({
  wig_id: Yup.string(), // not required in frontend, automatically generated
  color: Yup.string().required("Required"),
  length: Yup.number().typeError("Length must be a number").required("Required"),
  cap_size: Yup.string().required("Required").default('M'),
  material: Yup.string().nullable(),
  hairstyle: Yup.string().nullable(),
  cost_subtotal: Yup.number().default(0),
  price: Yup.number().default(0),
  service_price: Yup.number().default(0),
  wig_type: Yup.string().nullable(),
  inventory_item_id: Yup.string().nullable()
})

export { tabs, filters, headers, mobile_headers, fields, initialValues, schema, additionalState, edit_fields };
